import { LocaleCode, SUPPORTED_LANGUAGES } from "@/utils/locale";
import { useEffect, useState } from "react";
import translations from "../../lang/translations-guest.js";

type languageType = LocaleCode;

const useTranslation = () => {
  const [locale, setLocale] = useState<LocaleCode>("en");
  const [t, setT] = useState(translations.en);

  useEffect(() => {
    const userLanguages = navigator.languages || ["en"];
    const detectedLocale = userLanguages[0].slice(0, 2);

    const isSupported = SUPPORTED_LANGUAGES.some(
      (lang) => lang.code === detectedLocale,
    );

    if (
      isSupported &&
      detectedLocale in translations &&
      detectedLocale !== locale
    ) {
      setLocale(detectedLocale as LocaleCode);
      setT(translations[detectedLocale as keyof typeof translations]);
    }
  }, []);

  return { locale, t };
};

export default useTranslation;
